export default __webpack_public_path__ + "static/EuclidFlex-Medium-WebXL-ee92693187c4425cb289d2511f15f1c7.woff2";